'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import useAuth from '@/utils/use-auth'

export default function Home() {
  const router = useRouter()
  const userData = useAuth()

  useEffect(() => {
    if (!userData) return
    const isAdmin = userData.permissions?.includes('admin') ?? false
    router.replace(isAdmin ? '/dashboard' : '/media/generations')
  }, [userData, router])

  return null
}
